import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '../../config';
import { handleNetworkError } from '../utilities/axiosUtilities';
export class LicensePayload {
  constructor() {
    this.defaultLicenseType = void 0;
    this.defaultTrialLength = void 0;
    this.defaultLicenseSeats = void 0;
  }
}
export function getPackages() {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/packages`;
  return axios.get(url).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function getVersionsByPackageId(packageId) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/packages/${packageId}`;
  return axios.get(url).then(({
    data
  }) => {
    if (data && data.allPackageVersions) {
      return data.allPackageVersions;
    }
    return [];
  });
}
export function getPackageVersion(packageVersionId) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/package-versions/${packageVersionId}`;
  return axios.get(url).then(({
    data
  }) => data).catch(handleNetworkError);
}
export function registerPackageInLMO(packageVersionId, orgCredentials) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/package-versions/${packageVersionId}`;
  return axios.post(url, orgCredentials).then(({
    data
  }) => data).catch(function (error) {
    throw error;
  });
}
export function setDefaultLicense(packageVersionId, defaultLicensePayload) {
  const url = `${PUBLISHING_SERVICE_URL}/publishing/package-versions/${packageVersionId}`;
  return axios.put(url, defaultLicensePayload).then(({
    data
  }) => data).catch(handleNetworkError);
}